import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import NavbarBottom from './NavbarBottom';

const PengumumanDetail = () => {

    const params = useParams();
    const [newsDetail, SetNewsDetail] = useState([]);
    const [newsList, SetNews] = useState([]);
    const urlImg = `${process.env.REACT_APP_BASEURL}/galeri/`;

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_ENDPOINT}/pengumuman-detail/${params.id}`)
            .then((res) => {
                return res.json();
            })
            .then((datas) => {
                //console.log(datas);
                SetNewsDetail(datas.data[0]);
            });

        fetch(`${process.env.REACT_APP_API_ENDPOINT}/pengumuman`)
            .then((res) => {
                return res.json();
            })
            .then((datas) => {
                //console.log(datas.data);
                SetNews(datas.data);
            });


        //console.log(newsDetail);
    }, []);


    return (
        <>
            <NavbarBottom />
            <div className="p-4 bg-sky-50">
                <div class="flex flex-wrap justify-between">
                    <div class="bg-white w-full md:w-8/12 px-4 mb-8 rounded"><br />
                        <img src={urlImg + '' + newsDetail.file} alt="Berita Image" class="w-full object-cover rounded" />
                        <h2 class="font-bold mt-2 mb-2" style={{ fontFamily: 'MuseoSansRounded300', fontSize: 16 }}>
                            {newsDetail.name}
                        </h2>

                    </div>
                    <div class="w-full md:w-4/12 px-4 mb-8">
                        <div class="bg-gray-100 px-4 py-6">
                            <h3 class="font-bold text-left" style={{ fontSize: 18 }}>
                                <span class="text-[#FF3C3C]">
                                    PENGUMUMAN LAIN
                                </span>
                            </h3>
                        </div>
                        <div class="flex flex-col divide-y dark:divide-gray-300 bg-white px-4" style={{ fontFamily: 'MuseoSansRounded900', fontSize: 14 }}>
                            {newsList.filter((item) => item.id != params.id).map((data_news, indexnews_list) => (
                                <div class="flex px-1 py-4">
                                    <img src={urlImg + '' + data_news.file} alt="" class="flex-shrink-0 object-cover w-20 h-20 mr-4 dark:bg-gray-500" />
                                    <div class="flex flex-col flex-grow">
                                        <a rel="noopener noreferrer" href={`/detail-pengumuman/${data_news.id}/${data_news.name}`} class="hover:underline" style={{ fontSize: 12 }}>

                                            {data_news.name}

                                        </a>
                                    </div>
                                </div>
                            ))}
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default PengumumanDetail;
